import React from 'react';
import { Outlet } from 'react-router-dom';

const AuthLayout = () => {
  return (
    <div
      className="aurora-shell relative grid min-h-screen w-full grid-cols-1 overflow-hidden md:grid-cols-[1.1fr_0.9fr]"
    >
      <div className="relative flex h-full items-center justify-center px-6 py-12 sm:px-10">
        <div className="relative z-[1] w-full max-w-xl rounded-3xl bg-[color:var(--shell-card)]/95 px-6 py-10 shadow-[var(--shadow-soft)] backdrop-blur-xl sm:px-10">
          
          <Outlet />
        </div>
        <div className="pointer-events-none absolute inset-6 -z-[1] rounded-[40px] border border-white/40 bg-white/30 blur-3xl" />
      </div>

      <div className="relative hidden h-full items-center justify-center overflow-hidden bg-transparent md:flex">
        <div className="relative h-[88%] w-[88%] max-w-xl overflow-hidden rounded-[40px] bg-gradient-to-br from-white/35 via-white/10 to-white/5 shadow-[var(--shadow-soft)] backdrop-blur-[68px]">
          <img
            src="/images/granny.png"
            alt="Kinn culinary vision"
            className="h-full w-full object-cover opacity-90 mix-blend-luminosity"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#B7C9FF]/65 via-transparent to-transparent" />
          <div className="absolute bottom-8 left-8 right-8 text-sm text-text-primary/80">
            <div className="flex items-center justify-between text-xs uppercase tracking-[0.35em] text-terracotta">
              <span>Seller Stories</span>
              <span>Curated by Kinn</span>
            </div>
            <p className="mt-3 text-text-primary/70">
              "Kinn empowers food entrepreneurs with AI tools and no approval gates, making it easy to turn passion into profit."
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
